module.exports = __webpack_public_path__ + "static/media/evening-slot-icon.d3c3450e.svg";